import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  key: 0,
  id: "infinite-scrolling-loading",
  "class": "tw-text-center tw-text-w-primary tw-pb-20px"
};
var _hoisted_2 = {
  key: 1,
  "class": "tw-text-center"
};
var _hoisted_3 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_insertion_card = _resolveComponent("insertion-card");
  return _openBlock(), _createElementBlock("div", {
    id: "similar-re-container",
    "class": _normalizeClass(["container-list", {
      'tw-overflow-hidden': _ctx.isFavourites
    }])
  }, [_createElementVNode("ul", {
    "class": _normalizeClass(["tw-p-0", {
      'tw-flex max-sm:tw-flex-col tw-overflow-auto tw-gap-15px tw-no-scrollbar': _ctx.isFavourites
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.realEstateList, function (re) {
    return _openBlock(), _createBlock(_component_insertion_card, {
      key: re.id,
      vertical: _ctx.vertical,
      "real-estate": re,
      "class": "tw-mb-10px"
    }, null, 8 /* PROPS */, ["vertical", "real-estate"]);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */), _ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.loadingLabel) + "... ", 1 /* TEXT */)) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("a", {
    "class": "tw-btn btn-link !tw-text-w-primary",
    href: _ctx.similarListingUrl,
    rel: "nofollow"
  }, _toDisplayString(_ctx.viewAllLabel), 9 /* TEXT, PROPS */, _hoisted_3)]))], 2 /* CLASS */);
}